import { render } from "./CareerView.vue?vue&type=template&id=5b48948c"
import script from "./CareerView.vue?vue&type=script&lang=js"
export * from "./CareerView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__